import API from '../../../../../services/api';

export const TICKETS_API = {
    get: async (tab, entityId) => {
        return API.post('/tickets/get-pending', {tab, entityId}).then(res => res.data);
    },
    getCount: async () => {
        return API.get('/tickets/get-count').then((res) => res.data);
    },
    assign: async (ticketId, presupuestoId) => {
        return API.post('/tickets/assign', {ticketId, presupuestoId}).then(res => res.data);
    },
    unassign: async (ticketId) => {
        return API.post('/tickets/unassign', {ticketId}).then(res => res.data);
    },
    changeStatus: async (data) => {
        return API.post('/tickets/change-state', data).then((res) => res.data);
    }
}

